import { createApp } from "vue";
import axios from "axios";
import i18n from "../plugins/i18n";
import App from "./App.vue";
import router from "./router.js";
import store from "./store.js";

import "umaui/dist/style.css";

const rootProps = {
  language: window.currentLanguage,
  baseUrl: window.siteUrl,
  themePath: window.themePath,
  id: window.faculdadeid,
  faculdade: window.faculdadename,
};

axios.get(import.meta.env.VITE_APP_TRANSLATION_FILE_URL + "?lang=" + window.currentLanguage)
  .then((data) => {
    const app = createApp(App, rootProps);
    const i18nStrings = data.data;
    app.config.unwrapInjectedRef = true;
    app.use(i18n, i18nStrings);
    app.use(router);
    app.use(store);
    app.mount("#app");
  })
  .catch((error) => {
    console.log(error);
  });
